import { c as _c } from "react/compiler-runtime";
import { useLocation } from 'react-router-dom';
import usePostHogFeatureFlag from 'hooks/usePostHogFeatureFlag';

// PostHog experiment for the CON-8777 customization & layout A/B test. `test`
// is the restructured page, `control` (or no value) keeps the current one.
// Consumer's config/postHogConstants.js declares the same key for the
// server-side evaluation that follows; rename both together.
export const PDP_LAYOUT_REVAMP_FLAG = 'pdp-layout-revamp';
export const PDP_LAYOUT_REVAMP_TEST_VARIANT = 'test';

// `?layoutRevamp=1` forces the new layout on any environment so design and QA
// can review it without waiting on a bucket assignment. `?layoutRevamp=0`
// forces the control back for the same reason.
const readPreviewOverride = search => {
  const value = new URLSearchParams(search).get('layoutRevamp');
  if (value === '1') {
    return true;
  }
  if (value === '0') {
    return false;
  }
  return null;
};
const useIsLayoutRevampVariant = () => {
  const $ = _c(2);
  const {
    search
  } = useLocation();
  const flagValue = usePostHogFeatureFlag(PDP_LAYOUT_REVAMP_FLAG);
  let t0;
  if ($[0] !== search) {
    t0 = readPreviewOverride(search);
    $[0] = search;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const previewOverride = t0;
  if (previewOverride !== null) {
    return previewOverride;
  }
  return flagValue === PDP_LAYOUT_REVAMP_TEST_VARIANT;
};
export default useIsLayoutRevampVariant;